import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import background from "../../assets/images/Rectangle-background.svg";
import "../Portfolio.css";
import Carousel from "./Carousel";
import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";

function Portfolio() {
  let navigate = useNavigate();

  const handleClick = () => {
    navigate("/portfolio");
  };

  return (
    <div className="mb-40">
      <div className="absolute z-0 mt-[-16%] ml-[-25%]">
        <img src={background} />
      </div>
      <div className="relative flex flex-col justify-center items-center z-10">
        <h1 className="text-cool-400 font-bold text-6xl font-monts">
          Portfolio
        </h1>
        <div className="w-[80%]  mt-20 mb-48">
          <Carousel />
        </div>
        <div>
          <Link
            to="/portfolio"
            className="hover:bg-cool-400 group hover:text-white bg-cool-100 rounded-md shadow-md duration-700 ease-out hover:shadow-xl p-2 px-16 font-monts text-cool-400 text-xl xmd:text-xl font-semibold flex items-center"
          >
            <span className="group-hover:-translate-x-2 duration-700 ease-out">
              See my work
            </span>
            <BsArrowRight
              size={60}
              className="ml-4 group-hover:translate-x-8 group-hover:fill-white duration-700 ease-out fill-cool-400"
            />
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Portfolio;
